<template>
  <div class="granular-insights i-px-12 i-py-13">
    <div class="granular-insights__wrapper">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <router-link
            :to="`/customer/${$route?.params?.customer_id}/credit`"
            class="i-mr-sm"
          >
            <i-button
              left-icon="medium-arrows-left"
              data-dd-action-name="credit-granular-insights-back-button"
              :size="iButtonSizes.SMALL"
              :type="iButtonTypes.NEUTRAL"
              :button-style="iButtonStyles.GHOST"
              data-testid="customer-page-back-button"
            />
          </router-link>
          <div class="d-flex flex-column">
            <div class="d-flex i-mb-2">
              <h1 class="i-text-heading-5 i-text-neutral-120 i-m-0">
                {{ pageTitle }} Insights
              </h1>
            </div>
            <p class="i-text-body-2 i-text-neutral-110">
              {{ pageSubTitle }}
            </p>
          </div>
        </div>
        <credit-header-date type="granular" />
      </div>
      <div class="granular-insights__components i-radius-xl i-p-10 i-mt-13">
        <total-barchart :type="insightType" />
        <top-five-doughnut-chart
          v-if="insightsTotalsLoaded"
          :type="insightType"
        />
        <credit-transactions
          :table-title="creditTransactionsHeading"
          :category-filter="insightType"
          class="i-mt-13"
        ></credit-transactions>
      </div>
    </div>
  </div>
</template>

<script>
import {
  iButton,
  iButtonSizes,
  iButtonStyles,
  iButtonTypes,
} from '@inscribe/signal';
import { mapState, mapActions, mapGetters } from 'vuex';
import constants from './constants';
import componentText from './components/components.text';

import CreditHeaderDate from '@/V2/credit/components/CreditHeaderDate';
import TopFiveDoughnutChart from '@/V2/credit/charts/top-five-doughnut-chart/TopFiveDoughnutChart';
import TotalBarchart from '@/V2/credit/charts/total-barchart/TotalBarchart';
import CreditTransactions from '@/V2/credit/components/CreditTransactions';

export default {
  components: {
    iButton,
    CreditHeaderDate,
    CreditTransactions,
    TopFiveDoughnutChart,
    TotalBarchart,
  },
  beforeRouteLeave(to, from, next) {
    this.resetGranularInsights();
    next();
  },
  data() {
    return {
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
    };
  },
  computed: {
    ...mapGetters(['insightsTotals']),

    insightType() {
      return this.$route.params.type;
    },

    pageTitle() {
      return constants[this.insightType].title;
    },

    pageSubTitle() {
      return constants[this.insightType].subtitle;
    },

    creditTransactionsHeading() {
      return componentText[this.insightType].creditTransactions.title;
    },

    insightsTotalsLoaded() {
      return (
        this.insightsTotals.credits_total !== undefined &&
        this.insightsTotals.debits_total !== undefined
      );
    },
  },
  methods: {
    ...mapState({
      credit: 'credit',
    }),

    ...mapActions(['resetGranularInsights']),
  },
};
</script>

<style lang="scss" scoped>
.granular-insights {
  height: 100%;
  background: $light-neutral-default;
  overflow: auto;

  &__wrapper {
    max-width: 1200px;
    margin: 0 auto;
  }

  &__components {
    border: 1px solid $light-neutral-60;
  }
}
</style>
